'use client';

import { Text } from '@actr/ui/src/components/_atoms/text';
import { Modal } from '@actr/ui/src/components/_modals/modal';
import { observer } from 'mobx-react-lite';
import React from 'react';

import * as Styled from '../style.css';

export type SuccessAddedReviewModalProps = {
    isShowModal: boolean;
    onClose: () => void;
    isMobile: boolean;
}

const SuccessAddedReviewModal: React.FC<SuccessAddedReviewModalProps> = ({ isShowModal, onClose, isMobile }) => (
  <Modal
    className={Styled.Modal()}
    Title="Отзыв отправлен"
    isPopup={!isMobile}
    open={isShowModal}
    disableFooterCloseButton={true}
    onClose={onClose}
    onClickFooterButtonOk={onClose}>
    <Text font="paragraph.m">
      После проверки отзыв будет размещен на сайте
    </Text>
  </Modal>
);

export default observer(SuccessAddedReviewModal);
